<template>
<div class="chapter">
<div class="inner_page">
<div class="titlepage">
<h2 class="author"><b>Mari Hannah</b></h2>
<h1 class="title"><a id="pageiv"></a><a id="pagev"></a>The <span class="big">Death</span> Messenger</h1>
<p class="logo"><img alt="" src="OEBPS/images/logo.jpg"/></p>
<p class="title5">Minotaur Books</p>
<p class="underline">  </p>
<p class="title5">A Thomas Dunne Book</p>
<p class="title6">New York</p>
<p class="logo1"><img alt="" src="OEBPS/images/logo1.jpg"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// tp.vue?f913ded8